import React, {   useState } from 'react'
import styled from 'styled-components'
import { useEventListener } from 'usehooks-ts'

export const Debug = ({
  size,
}: {
  size: { width: number; height: number }
}) => {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 })

  const handleMouseMove = (e: MouseEvent) => {
    setCursorPosition({
      x: +((e.offsetX * 100) / size.width).toFixed(1),
      y: +((e.offsetY * 100) / size.height).toFixed(1),
    })
  }
  useEventListener('mousemove', handleMouseMove)
  return (
    <StyledDebug left={cursorPosition.x} top={cursorPosition.y}>
      {cursorPosition.x}, {cursorPosition.y}
    </StyledDebug>
  )
}

const StyledDebug = styled.div<{ left: number; top: number }>`
  pointer-events: none;
  position: absolute;
  top: ${({ top }) => top + '%'};
  left: ${({ left }) => left + '%'};
  transform: translateY(-100%);
`
